export default __webpack_public_path__ + "static/media/header3.f8771296.jpg";